import { useEffect } from "react";

const DiscoverySessionSection = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <section id="discovery-session" className="w-full py-20 md:py-28 bg-card border-y border-border">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="mb-12 max-w-2xl">
            <div className="flex items-center gap-3 mb-5">
              <span className="rule-gold" aria-hidden />
              <p className="eyebrow">Discovery session</p>
            </div>
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-semibold leading-[1.1] mb-5">
              Pick a time and let's talk about your book.
            </h2>
            <p className="text-lg text-muted-foreground leading-relaxed">
              Thirty minutes, no pitch deck. Tell us where the book is today and we will tell you the
              most useful next step — even if that step is not with us.
            </p>
          </div>

          <div className="card-noir p-4 md:p-6 overflow-hidden">
            <div
              className="meetings-iframe-container"
              data-src="https://meetings.series-a.co/meetings/series-a/authorpro?embed=true"
              style={{ height: "650px" }}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default DiscoverySessionSection;
